/**
 * navigator.clipboard.writeText tiho puca (odbijeno obećanje bez greške u
 * konzoli) na stranicama servisiranim preko običnog HTTP-a na bilo čemu
 * osim "localhost" - browseri to smatraju "nesigurnim kontekstom". Ovo je
 * čest slučaj kad se aplikacija testira preko IP adrese VM-a bez HTTPS-a.
 * Fallback koristi stari `document.execCommand('copy')` trik preko
 * privremenog textarea elementa, koji radi u širem broju konteksta.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // padni na fallback ispod
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}
